<template>
  <div>
    <div class="tag-box" :style="{backgroundColor:findObj.color}">
      <div class="content">
        {{findObj.label}}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    sType: String
  },
  data() {
    return {
      sTypeList: [{
        label: 'SP',
        value: '0',
        color: '#3B6CFF'
      },
      {
        label: 'SB',
        value: '1',
        color: '#FF763B'

      },
      {
        label: 'SD',
        value: '2',
        color: '#4EB92A'
      }],
    }
  },
  computed: {
    findObj() {
      return this.sTypeList.find(i => i.value === this.sType)
    }
  },
  mounted() {

  },

  methods: {

  }
}
</script>

<style scoped lang='scss'>
.tag-box{
  width: 32px;
  height: 18px;
  border-radius: 2px;
  .content{
    font-size: 12px;
    color: #FFFFFF;
    line-height: 18px;
    text-align: center;
  }
}
.sp-bg-color{
  background: #3B6CFF;
}
.sb-bg-color{
  background: #FF763B;
}
.sd-bg-color{
  background: #4EB92A;
}
</style>
